module.exports = __webpack_public_path__ + "img/vwclass-intro.3e3e3938.png";